import { useRouter } from 'next/router';
import { useParseQuery } from '@/hooks/useParseQuery';
import { isSimCardsCategoryPath } from '@/features/PhoneNumberSearch/helpers';
import { getCurrentCategoryPath } from '@/hooks/useCurrentCategory/useCurrentCategory.helpers';

export function usePhoneNumberHighlightFilter() {
  const {
    query: { slug },
  } = useRouter();
  const { propertyOptions } = useParseQuery(true);

  if (!isSimCardsCategoryPath(getCurrentCategoryPath(slug))) {
    return undefined;
  }

  return propertyOptions.string[0]?.value;
}
